import { render } from "./ImportHistoryDetailVx.vue?vue&type=template&id=1b99296d&scoped=true"
import script from "./ImportHistoryDetailVx.vue?vue&type=script&lang=js"
export * from "./ImportHistoryDetailVx.vue?vue&type=script&lang=js"

import "./ImportHistoryDetailVx.vue?vue&type=style&index=0&id=1b99296d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b99296d"]])

export default __exports__